module.exports = __webpack_public_path__ + "img/download-billing-big-active.f2422ccd.png";